import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));

// Check if we're in development mode
const isDevelopment = process.env.NODE_ENV === 'development';

// To prevent WebSocket connection issues in development, we can disable StrictMode if needed
// which causes double mounting of components
if (isDevelopment) {
  // In development, render without StrictMode to avoid double WebSocket connections
  root.render(<App />);
  // eslint-disable-next-line no-console
  console.log('Running in development mode with StrictMode disabled to prevent WebSocket issues');
} else {
  // In production, use StrictMode
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
reportWebVitals();
